import { any } from "@altostra/type-validations/lib/primitives";

export const isSegmentInsightsStats = any;
